import { setDraft,getDraft } from '@/api'
import { Loading, Message } from 'element-ui';

/* 
type : 1  //投诉评价处理页面
*/
// 保存草稿
export function handleSetDraft(obj) {
  Loading.service();
  const { form, type, bizId } = obj
  const content = JSON.stringify(form)
  const params = {
    bizId,
    type,
    content
  }
  setDraft(params).then((res) => {
    const { code } = res
    if (code === 0) {
      Message({
        message: '保存成功！',
        type: 'success',
        duration: 1000,
      })
    }
  }).finally(() => {
    Loading.service().close();
  })
}
export async function handleGetDraft(obj) {
  const { type, bizId } = obj
  const params = {
    bizId,
    type
  }
  let draft = {}
  const  { code, data }  = await getDraft(params)
    if (code === 0) {
      return JSON.parse(data)
    }
}